import {ReactNode} from "react";
import {Select, SelectProps} from "@mui/material";
import {Colors} from "../../ui";

export type CustomSelectType = "consumer";

type CustomSelectProps = SelectProps<string> & {
  children: ReactNode;
  type?: CustomSelectType;
};

const getSelectStyles = (type: CustomSelectType) => {
  switch (type) {
    case "consumer":
    default:
      return {
        textColor: Colors.primary._800,
        backgroundColor: "white",
        borderColor: Colors.primary._200,
        hoverColor: Colors.primary._100,
        iconColor: Colors.primary._600,
      };
  }
};

export const CustomSelect = ({children, type = "consumer", ...props}: CustomSelectProps) => {
  const selectStyles = getSelectStyles(type);

  return (
    <Select
      {...props}
      sx={{
        minWidth: "100%",
        backgroundColor: selectStyles.backgroundColor,
        borderRadius: "8px",
        "& .MuiSelect-select": {
          padding: "8px",
          color: selectStyles.textColor,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: selectStyles.borderColor,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: selectStyles.borderColor,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: selectStyles.borderColor,
          borderWidth: 1,
        },
        "& .MuiSelect-icon": {
          color: selectStyles.iconColor,
        },
      }}
      MenuProps={{
        PaperProps: {
          elevation: 3,
          sx: {
            marginTop: "2px",
            marginLeft: "-8px",
            border: `1px solid ${selectStyles.borderColor}`,
            borderRadius: "8px",
            backgroundColor: selectStyles.backgroundColor,
            "& .MuiList-root": {
              padding: 0,
            },
            "& .MuiMenuItem-root": {
              padding: "8px 14px",
              color: selectStyles.textColor,
              "&:hover": {
                backgroundColor: selectStyles.hoverColor,
                borderRadius: "4px",
              },
              "&.Mui-selected": {
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: selectStyles.hoverColor,
                },
              },
            },
          },
        },
      }}
    >
      {children}
    </Select>
  );
};
